import { Box, Card, CardContent, Skeleton } from '@mui/material';
import React from 'react';

export default function PendingRequestSkeleton() {
  return (
    <Card>
      <CardContent>
        <Skeleton variant="h4" width="70%" />
        <Box sx={{ mt: '16px', mb: '44px' }}>
          <Box sx={{ mb: '16px' }}>
            <Skeleton />
          </Box>
          <Box sx={{ mb: '16px' }}>
            <Skeleton />
          </Box>
          <Box sx={{ mb: '16px' }}>
            <Skeleton />
          </Box>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Skeleton variant="rectangular" width="45%" height="50px" />
          <Skeleton variant="rectangular" width="45%" height="50px" />
        </Box>
      </CardContent>
    </Card>
  );
}
